import fetch from '../utils/fetch';

export const getGiftProducts = brand =>
  fetch(`gifts/products?brand=${brand}`, null, { method: 'GET' });

export const purchase = payload =>
  fetch('gifts/purchase', null, {
    method: 'POST',
    body: JSON.stringify({ ...payload })
  });
